import React from 'react';
import {GridMultilineCell, GridMultilineBooleanCell} from 'core/components';
function resolveColumns(columns){
   columns.forEach(col=>{
       if(col.cell && col.cell === GridMultilineCell){
           const cell = (props)=><GridMultilineCell {...props} {...col.cellProps} {...col}/>
           col.cell = cell;
       }
       if(col.cell && col.cell === GridMultilineBooleanCell){
            const cell = (props)=><GridMultilineBooleanCell {...props} {...col.cellProps} {...col}/>
            col.cell = cell;
        }
   });
   return columns;
}
export{
   resolveColumns
}